__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "dvs-support-dcp-client-react";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@dtna/dvs-core-dcp-client-constants", "1.14.4", () => (Promise.all([__webpack_require__.e(1724), __webpack_require__.e(9438)]).then(() => (() => (__webpack_require__(39438))))));
			register("@dtna/dvs-core-dcp-ui-libraries", "6.23.7", () => (Promise.all([__webpack_require__.e(9244), __webpack_require__.e(1724), __webpack_require__.e(5035), __webpack_require__.e(159), __webpack_require__.e(4914), __webpack_require__.e(375), __webpack_require__.e(2272), __webpack_require__.e(6672), __webpack_require__.e(9708), __webpack_require__.e(1866), __webpack_require__.e(2018)]).then(() => (() => (__webpack_require__(10159))))));
			register("@microsoft/applicationinsights-web", "3.3.5", () => (Promise.all([__webpack_require__.e(3432), __webpack_require__.e(7256)]).then(() => (() => (__webpack_require__(83432))))));
			register("@microsoft/clarity", "1.0.0", () => (__webpack_require__.e(4075).then(() => (() => (__webpack_require__(56456))))));
			register("@reduxjs/toolkit", "1.9.7", () => (Promise.all([__webpack_require__.e(4887), __webpack_require__.e(4676), __webpack_require__.e(375), __webpack_require__.e(4875)]).then(() => (() => (__webpack_require__(44676))))));
			register("axios", "1.20.0", () => (Promise.all([__webpack_require__.e(728), __webpack_require__.e(2494)]).then(() => (() => (__webpack_require__(40728))))));
			register("buffer", "6.0.3", () => (__webpack_require__.e(8381).then(() => (() => (__webpack_require__(88381))))));
			register("dompurify", "3.4.17", () => (__webpack_require__.e(1408).then(() => (() => (__webpack_require__(51408))))));
			register("module-federation-import-remote", "1.0.23", () => (__webpack_require__.e(5733).then(() => (() => (__webpack_require__(55733))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(879), __webpack_require__.e(4914)]).then(() => (() => (__webpack_require__(20879))))));
			register("react-redux", "7.2.9", () => (Promise.all([__webpack_require__.e(4982), __webpack_require__.e(4914), __webpack_require__.e(6672), __webpack_require__.e(4113)]).then(() => (() => (__webpack_require__(72601))))));
			register("react-redux", "8.1.3", () => (Promise.all([__webpack_require__.e(6640), __webpack_require__.e(4914), __webpack_require__.e(6672)]).then(() => (() => (__webpack_require__(46640))))));
			register("react-router-dom", "6.30.6", () => (Promise.all([__webpack_require__.e(6456), __webpack_require__.e(4914), __webpack_require__.e(6672)]).then(() => (() => (__webpack_require__(16456))))));
			register("react", "18.2.0", () => (__webpack_require__.e(9198).then(() => (() => (__webpack_require__(49198))))));
			register("redux", "4.2.1", () => (__webpack_require__.e(390).then(() => (() => (__webpack_require__(70390))))));
			register("util", "0.12.5", () => (Promise.all([__webpack_require__.e(5035), __webpack_require__.e(7463)]).then(() => (() => (__webpack_require__(77463))))));
			register("web-vitals", "2.1.4", () => (__webpack_require__.e(9358).then(() => (() => (__webpack_require__(79358))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};